<template>
  <div></div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      routerName: '',
      queryObj: null
    };
  },
  created() {
    const { routerName, queryObj } = this.$route.query;
    this.routerName = routerName;
    this.queryObj = queryObj ? JSON.parse(queryObj) : null;
    this.CLOSE_BROWSINGHISTORYLIST(this.$route.name)
    this.$router.replace({
      name: this.routerName ? this.routerName : 'courseCenter_commodity_addCommodity_addCommodity',
      query: this.queryObj
    });
  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST',
    ]),
  }
};
</script>
